import React, { useEffect, useState } from "react";
import useGetRequest from "../../hooks/useGetRequest";
import { IOrderSettings } from "../../types/orderSettings.type";
import {
  Checkbox,
  Button,
  Spin,
  Alert,
  Form,
  message,
  Modal,
  Card,
} from "antd";
import { api } from "../../api/api";

export default function OrderSettings() {
  const { data, loading, error } = useGetRequest("/settings/order");
  const [orderSettings, setOrderSettings] = useState<IOrderSettings | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (data?.orderSettings) {
      setOrderSettings(data.orderSettings);
    }
  }, [data]);

  const updateOrderSettings = async (values: IOrderSettings) => {
    setIsLoading(true);
    try {
      await api.post("/settings/order", values);
      setOrderSettings(values);
      message.success("Настройки успешно обновлены!");
      setIsModalVisible(false);
    } catch (error) {
      message.error("Ошибка при обновлении настроек.");
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (loading) {
    return <Spin tip="Загрузка..." />;
  }

  if (error) {
    return <Alert message="Ошибка при загрузке данных" type="error" showIcon />;
  }

  return (
    <div>
      <h2>Настройки заказа</h2>

      {orderSettings && (
        <Card title="Текущие настройки" style={{ marginBottom: 16 }}>
          <p>
            <strong>Имя компании:</strong>{" "}
            {orderSettings.companyName ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Адрес компании:</strong>{" "}
            {orderSettings.companyAddress ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Телефон компании:</strong>{" "}
            {orderSettings.companyPhone ? "Показывать" : "Не показывать"}
          </p>

          <p>
            <strong>Имя клиента:</strong>{" "}
            {orderSettings.clientName ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Долг клиента:</strong>{" "}
            {orderSettings.clientDebt ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Валюта:</strong>{" "}
            {orderSettings.currency ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Тип клиента:</strong>{" "}
            {orderSettings.clientType ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Имя владельца:</strong>{" "}
            {orderSettings.ownerName ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Дата:</strong>{" "}
            {orderSettings.date ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Цена:</strong>{" "}
            {orderSettings.price ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Количество:</strong>{" "}
            {orderSettings.quantity ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Количество КГ:</strong>{" "}
            {orderSettings.quantityKg ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Итого:</strong>{" "}
            {orderSettings.total ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Ед.измерения:</strong>{" "}
            {orderSettings.unitOfMeasurement ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Подпись:</strong>{" "}
            {orderSettings.sign ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Остаток до:</strong>{" "}
            {orderSettings.residueBefore ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Остаток после:</strong>{" "}
            {orderSettings.residueAfter ? "Показывать" : "Не показывать"}
          </p>
        </Card>
      )}

      <Button type="primary" onClick={showModal}>
        Изменить настройки
      </Button>

      <Modal
        title={orderSettings ? "Обновить настройки" : "Добавить настройки"}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        <Form
          initialValues={orderSettings || {}}
          onFinish={updateOrderSettings}
          layout="vertical"
        >
          <Form.Item
            name="companyName"
            label="Имя компании"
            valuePropName="checked"
          >
            <Checkbox>Показывать навзвание компании</Checkbox>
          </Form.Item>

          <Form.Item
            name="companyPhone"
            label="Телефон компании"
            valuePropName="checked"
          >
            <Checkbox>Показывать телефон компании</Checkbox>
          </Form.Item>

          <Form.Item
            name="companyAddress"
            label="Адрес компании"
            valuePropName="checked"
          >
            <Checkbox>Показывать адрес компании</Checkbox>
          </Form.Item>

          <Form.Item
            name="clientName"
            label="Имя клиента"
            valuePropName="checked"
          >
            <Checkbox>Показывать имя клиента</Checkbox>
          </Form.Item>

          <Form.Item
            name="clientDebt"
            label="Долг клиента"
            valuePropName="checked"
          >
            <Checkbox>Показывать долг клиента</Checkbox>
          </Form.Item>

          <Form.Item name="currency" label="Валюта" valuePropName="checked">
            <Checkbox>Показывать валюту</Checkbox>
          </Form.Item>

          <Form.Item
            name="clientType"
            label="Тип клиента"
            valuePropName="checked"
          >
            <Checkbox>Показывать тип клиента</Checkbox>
          </Form.Item>

          <Form.Item
            name="ownerName"
            label="Имя владельца"
            valuePropName="checked"
          >
            <Checkbox>Показывать имя владельца</Checkbox>
          </Form.Item>

          <Form.Item name="date" label="Дата" valuePropName="checked">
            <Checkbox>Показывать дату</Checkbox>
          </Form.Item>

          <Form.Item name="price" label="Цена" valuePropName="checked">
            <Checkbox>Показывать цену</Checkbox>
          </Form.Item>

          <Form.Item name="quantity" label="Количество" valuePropName="checked">
            <Checkbox>Показывать количество</Checkbox>
          </Form.Item>

          <Form.Item
            name="quantityKg"
            label="Количество км"
            valuePropName="checked"
          >
            <Checkbox>Показывать количество км</Checkbox>
          </Form.Item>

          <Form.Item name="total" label="Итого" valuePropName="checked">
            <Checkbox>Показывать итоговую сумму</Checkbox>
          </Form.Item>

          <Form.Item
            name="unitOfMeasurement"
            label="Ед.измерения"
            valuePropName="checked"
          >
            <Checkbox>Показывать Ед.измерения</Checkbox>
          </Form.Item>

          <Form.Item name="sign" label="Подпись" valuePropName="checked">
            <Checkbox>Показывать подпись</Checkbox>
          </Form.Item>

          <Form.Item
            name="residueBefore"
            label="Остаток до"
            valuePropName="checked"
          >
            <Checkbox>Показывать остаток до</Checkbox>
          </Form.Item>

          <Form.Item
            name="residueAfter"
            label="Остаток после"
            valuePropName="checked"
          >
            <Checkbox>Показывать остаток после</Checkbox>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            style={{ marginTop: 16 }}
          >
            {orderSettings ? "Обновить настройки" : "Добавить настройки"}
          </Button>
        </Form>
      </Modal>
    </div>
  );
}
